import * as React from 'react';
import { compose, pure, withHandlers } from 'recompose';
import { Button } from '../Button';
import Popover from './Popover';
const ButtonPopover = (props) => {
    const { clickableComponent, testId = 'ButtonPopover', children } = props;
    return (React.createElement(Popover, { "data-testid": `${testId}`, clickableComponent: clickableComponent, position: "bottomRight" }, children));
};
const ComposedButtonPopover = compose(pure, withHandlers({
    clickableComponent: ({ icon, labelButton, testId = 'ButtonPopover' }) => ({ setOpen, open, }) => (React.createElement(Button, { onClick: () => setOpen(!open), "data-testid": `${testId}-toggle`, label: labelButton, iconName: icon })),
}))(ButtonPopover);
ComposedButtonPopover.displayName = 'ButtonPopover';
export default ComposedButtonPopover;
//# sourceMappingURL=ButtonPopover.js.map